import { fetchApiQuery } from '@graphql/ApolloHasuraWrapper';
import { email_service_origin } from '@shared/config';

// The body of a synced email lives in the emails GCS bucket, served by the
// email service for the mailbox owner (sanitized server-side). One helper for
// every reader: feed cards, the thread reading pane, the reply/forward quote.
// Resolves to null when the message has no stored body; rejects on a
// transport or HTTP failure.
export const fetchEmailBody = async (
  messageId: string,
  createdBy: string,
): Promise<string | null> => {
  const response = await fetchApiQuery(
    `${email_service_origin}/api/get-email-body`,
    {
      method: 'POST',
      body: JSON.stringify({ ownerUserId: createdBy, messageId }),
    },
  );
  if (!response.ok) {
    throw new Error(`Failed to get email body (${response.status})`);
  }
  const data: { body?: string | null } = await response.json();
  return data.body ?? null;
};
